import { trackClick as originalTrackClick } from '@hotjar/tracking';

export enum PAGE {
  subscriptions = 'Subscriptions page',
  checkout = 'Checkout page',
  payment = 'Payment Details page',
  invoices = 'Invoices page',
}

export const SUBSCRIPTIONS_HEADER = {
  externalPricing: 'Learn about products',
  manageSubscriptions: 'Manage subscriptions',
} as const;

export const CHECKOUT_FOOTER_CTA = {
  continueToCheckout: 'Continue to checkout',
  invoiceDetails: 'Continue to payment details',
  invoiceDetailsSecondary: 'Continue with old details',
  reviewOrder: 'Confirm and pay',
} as const;

export enum PAYMENT_DETAILS_PAGE {
  upgradePlans = 'Upgrade plans',
  change = 'Change payment details',
  cancel = 'Cancel',
  save = 'Save payment details',
}

export enum INVOICES_PAGE {
  upgradePlans = 'Upgrade plans',
  edit = 'Edit',
  update = 'Update',
  save = 'Save changes',
  close = 'Close modal',
}

const UI_POSITION = {
  ...PAGE,
  checkoutFooter: 'Checkout Footer',
  accountOwnerPaymentOverdueAlert: 'Account owner payment overdue alert',
  billingNotifications: 'Billing notification emails',
} as const;

export const ALERTS_CTA = {
  updatePaymentDetails: 'Update payment details',
} as const;

export const trackClick = ({
  eventName,
  uiPosition,
  accountId,
}: {
  eventName: string;
  accountId: number;
  uiPosition: (typeof UI_POSITION)[keyof typeof UI_POSITION];
}): Promise<void> =>
  originalTrackClick({
    name: eventName,
    uiPosition,
    groupData: {
      account_id: accountId,
    },
  });
